import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#062364] text-white pt-16 pb-12 border-t border-[#228A47]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-white/10">
          
          {/* Brand Info */}
          <div className="space-y-4">
            <div>
              <h3 className="text-xl font-bold tracking-tight text-white">
                Rolskov Bowtech
              </h3>
              <p className="text-sm font-semibold text-[#228A47] mt-0.5">
                Bowtech-behandling i Skårup
              </p>
            </div>
            <p className="text-sm text-slate-300 leading-relaxed">
              Personlig og nærværende Bowtech-behandling hos Jørn Rolskov. En blid og målsat tilgang til at genoprette kroppens naturlige balance.
            </p>
          </div>

          {/* Contact Details */}
          <div className="space-y-4">
            <h4 className="text-base font-semibold text-white tracking-wide">
              Kontaktoplysninger
            </h4>
            <ul className="space-y-3 text-sm text-slate-300">
              <li className="flex items-start gap-3">
                <i className="fa-regular fa-user text-[#228A47] mt-1 shrink-0" aria-hidden="true"></i>
                <span>Jørn Rolskov</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-regular fa-location-dot text-[#228A47] mt-1 shrink-0" aria-hidden="true"></i>
                <span>Østergade 47, 5881 Skårup Fyn</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-regular fa-phone text-[#228A47] shrink-0" aria-hidden="true"></i>
                <a
                  href="tel:27117557"
                  className="whitespace-nowrap hover:text-[#228A47] transition-colors font-medium text-white"
                >
                  27 11 75 57
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-regular fa-envelope text-[#228A47] shrink-0" aria-hidden="true"></i>
                <a
                  href="mailto:joern@rolskov-bowtech.dk"
                  className="whitespace-nowrap hover:text-[#228A47] transition-colors text-white"
                >
                  joern@rolskov-bowtech.dk
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-base font-semibold text-white tracking-wide">
              Navigation
            </h4>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li>
                <Link to="/" className="hover:text-[#228A47] transition-colors">Forside</Link>
              </li>
              <li>
                <Link to="/projects" className="hover:text-[#228A47] transition-colors">Om Bowtech</Link>
              </li>
              <li>
                <Link to="/behandlingen" className="hover:text-[#228A47] transition-colors">Behandlingen</Link>
              </li>
              <li>
                <Link to="/om-jorn" className="hover:text-[#228A47] transition-colors">Om Jørn</Link>
              </li>
              <li>
                <Link to="/about-us" className="hover:text-[#228A47] transition-colors">Priser &amp; Praktisk</Link>
              </li>
              <li>
                <Link to="/klienthistorier" className="hover:text-[#228A47] transition-colors">Klienthistorier</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#228A47] transition-colors">Kontakt</Link>
              </li>
            </ul>
          </div>

          {/* Practical Info Card */}
          <div className="space-y-4">
            <h4 className="text-base font-semibold text-white tracking-wide">
              Åbningstider &amp; Aftale
            </h4>
            <div className="bg-[#041845] p-4 rounded-xl border border-white/10 space-y-2 text-sm text-slate-300">
              <p className="font-medium text-white flex items-center gap-2">
                <i className="fa-regular fa-clock text-[#228A47]" aria-hidden="true"></i>
                Behandling efter aftale
              </p>
              <p className="text-xs text-slate-300">
                Ring eller e-mail for at aftale en tid i klinikken i Skårup.
              </p>
              <div className="pt-2">
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 text-xs font-semibold text-[#228A47] hover:text-white transition-colors"
                >
                  <span>Gå til kontaktsiden</span>
                  <i className="fa-regular fa-arrow-right" aria-hidden="true"></i>
                </Link>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} Rolskov Bowtech. Alle rettigheder forbeholdes.</p>
          <p className="text-slate-500">
            Bowtech-behandling af Jørn Rolskov · Skårup, Fyn
          </p>
        </div>
      </div>
    </footer>
  );
}
